import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Form }  from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { LinkContainer } from 'react-router-bootstrap';
import { useGetPublicplanQuery } from '../../slices/teachers/planApiSlice';
import {  useSubscribeinstripeMutation, useUpgradestripesubscriptionMutation, useGetProfileQuery } from '../../slices/students/studentsApiSlice';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { setStudentCredentials } from '../../slices/students/authStudentSlice';
import { toast } from 'react-toastify';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import PublicPlan from '../../components/PublicPlan';

const StudentsUpgradeSubscription = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [enroll, setEnroll] = useState(false);
    const [upgrade, setUpgrade] = useState(false);
    const [paysetup, setPaysetup] = useState('');
    const [subject, setSubject] = useState();
    const [planprice, setPlanprice] = useState();
    const [planpriceid, setPlanpriceid] = useState();
    const [planproductid, setPlanprodutid] = useState();
    const [teacherid, settTeacherid] = useState();
    const [cardname, setCardname] = useState();
    const [stripeid, setStripeid] = useState();
    const [onestill, setOnestill] = useState(false);
    const [oneispastdue, setOneispastdue] = useState(false);

    const { studentInfo } = useSelector((state) => state.authStudent);

    useEffect(() => {
        if(!studentInfo) {
            navigate('/studentlogin')
        }   
    }, [navigate, studentInfo])

    const [upgradestripesubscription, { isLoading: loading3, error: error3 }] = useUpgradestripesubscriptionMutation();
    const { data: plansData, error: plansError, isLoading: plansIsLoading } = useGetPublicplanQuery(id);
    const  { data, error2, isLoading2   } =  useGetProfileQuery();

    useEffect(() => {
        if(data && plansData) {
            setPlanpriceid(plansData?.plan.stripe_price_id);
            setPlanprice(plansData?.plan.price);
            settTeacherid(plansData?.plan.teacher);
            setSubject(plansData?.plan.subject)

            const subscription = data?.subscription.find(sub => sub.plan === id);
            data?.subscription.map((pla) => {
                
                if (pla.subject == plansData?.plan.subject && pla.active == true &&  pla.renewal == false &&  pla.questionsLeft > 0) {
                    setOnestill(true)
                }
                if (pla.subject == plansData?.plan.subject && pla.renewal == true && pla.plan != id) {
                    setStripeid(pla.stripe_subscription_id)
                }
                if (pla.subject == plansData?.plan.subject && pla.plan == id && pla.pastDue == true) {
                    setStripeid(pla.stripe_subscription_id);
                }
                if (pla.subject == plansData?.plan.subject && pla.active == true && pla.pastDue == true) {
                    setOneispastdue(true);
                }
            });
        }
    }, [data, plansData])

    const stripe = useStripe();
    const elements = useElements();
  
    if (!stripe || !elements) {
      return '';
    } 

    const handleSubmit = async (e) => {
        e.preventDefault();
        const cardElement = elements.getElement(CardElement);
        try {
            setLoading(true);
            const res = await upgradestripesubscription({ stripeid, oneispastdue, priceId: planpriceid, planprice, teacherid, id, onestill, subject }).unwrap();
            dispatch(setStudentCredentials({ ...res.updatedStudent }));
            const { paymentIntent, error } = await stripe.confirmCardPayment(res.clientSecret, {            
                payment_method: {
                  card: cardElement,
                  billing_details: {
                    name: cardname,
                  }
                }
        });
        navigate(`/studentafterupgradepayment/${id}`);
        } catch (error) {
            console.log(error);
            toast.error('Error making payment. Try again later.');  
        } 
        setLoading(false);        
      }

  return (
    <div>
        <StudentNavbar />
        <div className="main-content" id="panel">
            <StudentHeader /><br />
            <div className="container-fluid mt--5 loginResponsive"><br />                 
                <div className="container mt--10 pb-5 containerP subsc23">
                    <div className="row bg-gradient-defaultt titleContainerP ">
                            <h3 className=" tittleColor4 ">
                                <span className='tittleColor4' >
                                Subscribe to plan                                 
                                </span>
                            </h3><br />
                            {plansIsLoading ? ( 
                                <Loader />
                            ) : plansError ? (
                                <Message variant='danger'>
                                    {plansError?.data?.message || plansError.error}
                                </Message>
                            ) : (
                                <div className="offset-lg-1 col-lg-5 text-center"><br />
                                    <div className={`card card-pricing bg-gradient-primary shadow-lg rounded border-0 text-center mb-4` }>
                                        <div className="card-header bg-transparent">
                                            <h4 className="text-uppercase ls-1 text-white py-3 mb-0">Learning Plan</h4>
                                        </div>
                                        <div className="card-body px-lg-5">
                                            <div className="display-4 text-white">
                                            <span className='priceP3'>${plansData?.plan.price}</span>
                                                </div>
                                            <span className="text-white">monthly</span>
                                            <ul className="list-unstyled my-4">
                                                <li>
                                                    <div className="d-flex align-items-center">
                                                    <div>
                                                        <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                                                        <i className="fas fa-check"></i>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span className="pl-1 text-white">You can ask up to {plansData?.plan.totalQuestions} monthly questions </span>
                                                    </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="d-flex align-items-center">
                                                    <div>
                                                        <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                                                        <i className="fas fa-check"></i>
                                                        </div>
                                                    </div>
                                                    <div><br />
                                                    <span className="pl-2 text-white">&nbsp; &nbsp;Record your screen or camera <br /> to ask questions                                                        
                                                    </span>
                                                    </div>
                                                    </div>
                                                </li>                                                
                                            </ul>
                                        </div>
                                        <div className="card-footer bg-transparent card-footer2">
                                        </div>
                                    </div>    
                                </div>
                            )} 
                                {/* <div className="card bg-gradient-primary"> */}

                            <div className="  col-lg-5 text-center"><br />
                                <div className="card bg-gradient-info">
                                <div className="card-body"><br />
                                <div className="row justify-content-between align-items-center">                                                    
                                <form onSubmit={handleSubmit}>   
                                    <p className='payCard'>Make a Payment</p>    
                                    <img
                                     src="https://d2hl08zg7q4l7p.cloudfront.net/wp-content/uploads/2020/06/29203137/major-credit-card-logos-png-5.png"
                                      alt="Visa"
                                       className='payCard1' 
                                    />                             
                                    <div className="form-group">
                                            <div className="input-group input-group-alternative mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><i className="ni ni-single-02"></i></span>
                                            </div>
                                            <input 
                                                className="form-control" 
                                                placeholder="Name on card" 
                                                type="text" 
                                                value={cardname}
                                                onChange={(e) => setCardname(e.target.value)}

                                                />
                                            </div>
                                    </div>
                                    <div className="form-group">
                                    <CardElement className='elementCa form-control' />
                                    </div>
                                    {!loading ? (
                                        <>
                                        <button className="btn  btn-info bg-gradient-info">
                                            Submit Payment
                                        </button> <br /><br />
                                        </>
                                    ) : (   
                                        <>
                                        <Loader />
                                        processing payment...
                                        </>
                                    )}
                                </form>                                
                                </div>                                                                        
                                </div>
                                </div>
                            </div>
                        </div>                            
                    </div>
                </div>
            </div>                        
    </div>
  )
}

export default StudentsUpgradeSubscription
